import { useState, useEffect } from 'react'
import css from './WorkspaceProjectTitle.module.css'
import { TextH1 } from '../../../../ui/Text'
import EditableText from '../../../../ui/EditableText/EditableText'
import type { Project } from '@/store/projects/projectsSlice'

interface WorkspaceProjectTitleProps {
    project: Project
    onUpdateName: (name: string) => void
}

const WorkspaceProjectTitle = ({ project, onUpdateName }: WorkspaceProjectTitleProps) => {
    const [isEditingName, setIsEditingName] = useState(false)
    const [editNameValue, setEditNameValue] = useState('')

    useEffect(() => {
        setEditNameValue(project.name)
    }, [project])

    const handleStartEditing = () => {
        setEditNameValue(project.name)
        setIsEditingName(true)
    }

    const handleSaveName = () => {
        setIsEditingName(false)
        if (editNameValue !== project.name) {
            onUpdateName(editNameValue)
        }
    }

    const currentValue = isEditingName ? editNameValue : project.name
    const isEmpty = !currentValue || currentValue.trim() === ''
    const titleClassName = isEmpty ? `${css.title} ${css.titleEmpty}` : css.title

    return (
        <div className={css.header}>
            <div className={titleClassName}>
                <TextH1>
                    <EditableText
                        wrap={true}
                        isEditing={isEditingName}
                        text={isEmpty && !isEditingName ? 'Untitled project' : editNameValue}
                        onChange={setEditNameValue}
                        onBlur={handleSaveName}
                        onStartEditing={handleStartEditing}
                    />
                </TextH1>
            </div>
        </div>
    )
}

export default WorkspaceProjectTitle
